import { StoreOptions } from 'vuex';
import { SMH } from '@/renderer/scripts/smh';
export interface FileListCopyData {
  spaceId: string;
  type: string;
  fileList: SMH.SpaceFileItemData[];
}
const fileListCopy: StoreOptions<FileListCopyData> = {
  state: {
    spaceId: 'undefined',
    fileList: [],
    type: 'copy',
  },
  mutations: {
    SET_FILE_LIST_COPY_DATA(state: any, params: FileListCopyData): void {
      state.spaceId = params.spaceId;
      state.fileList = params.fileList;
      state.type = params.type;
    },
  },
};
export default fileListCopy;
